import firebase from "../configs/FirebaseConfig";
import { FIRESTORE_USERS_TABLE } from "../constants/FirestoreConstant";

const firestore = firebase.firestore();

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const geocodeAddress = async (address) => {
  if (!address) return null;
  const query = [address.street, address.houseNumber, address.zipCode, address.city].filter(Boolean).join(" ");
  const url = `https://nominatim.openstreetmap.org/search?format=json&limit=1&q=${encodeURIComponent(query)}`;
  try {
    const res = await fetch(url, {
      headers: { "Accept-Language": "nl", "User-Agent": "BombyxxCMS/1.0" },
    });
    const data = await res.json();
    if (data && data.length > 0) {
      return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon) };
    }
  } catch (e) {
    console.warn("Geocoding failed for:", query, e);
  }
  return null;
};

export const geocodeCustomers = async (customers, onProgress) => {
  const needsGeocoding = customers.filter(
    (c) =>
      c.address?.delivery &&
      !c.address.delivery.lat &&
      !c.address.delivery.lng &&
      !c.address.delivery.geocodeFailed,
  );

  if (needsGeocoding.length === 0) return;

  for (let i = 0; i < needsGeocoding.length; i++) {
    const customer = needsGeocoding[i];
    if (onProgress) onProgress(i + 1, needsGeocoding.length);

    const coords = await geocodeAddress(customer.address.delivery);
    if (coords) {
      try {
        await firestore
          .collection(FIRESTORE_USERS_TABLE)
          .doc(customer.id)
          .update({
            "address.delivery.lat": coords.lat,
            "address.delivery.lng": coords.lng,
          });
      } catch (e) {
        console.warn("Could not save coordinates for customer:", customer.id, e);
      }
    } else {
      try {
        await firestore
          .collection(FIRESTORE_USERS_TABLE)
          .doc(customer.id)
          .update({
            "address.delivery.geocodeFailed": true,
          });
      } catch (e) {
        console.warn("Could not mark geocode failure for customer:", customer.id, e);
      }
    }
    if (i < needsGeocoding.length - 1) {
      await sleep(1100);
    }
  }
};
